/* jshint esversion: 6 */
import React from 'react';
import InputBehaviorComponent from 'app/components/EditorComponents/InputBehaviorComponent.jsx';
import ErrorModule from 'app/mixins/ErrorModule.jsx';
import FieldError from 'app/components/common/FieldError.jsx';
import HelpButton from 'app/components/common/HelpButton.jsx';

class PinterestConfigPanel extends React.Component {
    constructor(props) {
        super(props);

        this.usernameHandler = this.usernameHandler.bind(this);

    }

    usernameHandler(e) {
        let nameEvent = {
                currentTarget: {
                    dataset: {
                        field: this.props.statePath + '.name'
                    }
                },
                target: {
                    value: e.target.value
                }
            };

        this.props.changeHandler(e);
        this.props.changeHandler(nameEvent);
    }

    render() {
        let behavior = null,
            constants = this.props.app.config.constants;

        if (this.props.routeType != constants.R_CURATE_BASIC) {
            behavior = (
                <InputBehaviorComponent
                    {...this.props}
                    input={this.props.input}
                    changeHandler={this.props.changeHandler}
                    statePath={this.props.statePath} />
            );
        }

        if (this.props.input === null || this.props.input === undefined) {
            return null;
        }

        return (
            <div className="editor-panel">
                <fieldset>
                    <legend>Pinterest User <HelpButton which="pinterestFeed"/><span className="required">*</span></legend>
                    <ErrorModule
                        app={this.props.app}
                        keys={['CURATION_INPUT_CREATE', 'INPUT_UPDATE', 'INPUT_CREATE', 'INPUT_VALIDATE']}
                        render={(state) => {
                            return (
                                <FieldError field="name" errors={state.errors}/>
                            );
                        }}/>
                    <ErrorModule
                        app={this.props.app}
                        keys={['CURATION_INPUT_CREATE', 'INPUT_UPDATE', 'INPUT_CREATE', 'INPUT_VALIDATE']}
                        render={(state) => {
                            return (
                                <FieldError field="url" errors={state.errors}/>
                            );
                        }}/>
                    <input type="text"
                        className="text-input med"
                        placeholder="Username"
                        defaultValue={this.props.input.subtypeUsername}
                        onChange={this.usernameHandler}
                        data-field={this.props.statePath + ".subtypeUsername"} />
                </fieldset>
                <fieldset>
                    <legend>Pinterest Board (optional)</legend>
                    <ErrorModule
                        app={this.props.app}
                        keys={['CURATION_INPUT_CREATE', 'INPUT_UPDATE', 'INPUT_CREATE', 'INPUT_VALIDATE']}
                        render={(state) => {
                            return (
                                <FieldError field="subtypeBoard" errors={state.errors}/>
                            );
                        }}/>
                    <input type="text"
                        className="text-input med"
                        placeholder="Board"
                        defaultValue={this.props.input.subtypeBoard}
                        onChange={this.props.changeHandler}
                        data-field={this.props.statePath + ".subtypeBoard"} />
                </fieldset>
                {behavior}
            </div>
        );
    }

};

PinterestConfigPanel.displayName = "PinterestConfigPanel";

export default PinterestConfigPanel;
